module.exports = __webpack_public_path__ + "img/Maschine Robot 3.f8570b4c.png";